import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { Company } from "@modules/companies/types/company";

import { ListCompaniesQueryFilters } from "./types";

export async function getCompaniesService(filters?: ListCompaniesQueryFilters): Promise<Company[]> {
  try {
    const { data } = await api.get<ApiResponse<Company>>(`v1/company_admin/`, {
      params: {
        page: filters?.page,
        page_size: filters?.perPage,
        search: filters?.search,
        ids: Array.isArray(filters?.ids) ? filters.ids.join(",") : undefined,
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching companies:", error);
    throw error;
  }
}
